export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(value || 0);
}

export function formatPercent(value: number): string {
  return (value || 0).toFixed(1) + '%';
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat('en-GB').format(value || 0);
}

export function formatDays(value: number): string {
  return (value || 0).toFixed(1) + ' days';
}

export function formatHours(value: number): string {
  return (value || 0).toFixed(1) + ' hrs';
}

export function formatChangePercent(value: number | undefined): string {
  if (value === undefined || value === null) return '';
  const sign = value >= 0 ? '+' : '';
  return sign + value.toFixed(1) + '%';
}
